angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "CONVERSATION_TRIP" : {
    "LOOKING_FOR_LOCALS": "{COUNT, plural, one{# person is} other{# people are}}",
    "OFFERS": "{COUNT, plural, one{Send an offer and show him around!} other{Send them offers and show them around!}}",
    "SEND_OFFERS": "{COUNT, plural, one{View} other{View all}}",
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/conversations_trips/conversation_trip.json
// module id = 426
// module chunks = 24